import { ToggleButton, ToggleButtonGroup } from '@cast/design-system';

import type { HeatmapViewMode } from '../utils/clusterHeatmap';

const MODE_OPTIONS: { value: HeatmapViewMode; label: string }[] = [
  { value: 'compute', label: 'Compute' },
  { value: 'health', label: 'Reliability' },
];

type HeatmapModeSwitcherProps = {
  mode: HeatmapViewMode;
  onModeChange: (mode: HeatmapViewMode) => void;
};

export const HeatmapModeSwitcher = ({
  mode,
  onModeChange,
}: HeatmapModeSwitcherProps) => (
  <ToggleButtonGroup
    size="sm"
    value={mode}
    onChange={(_event, value) => {
      if (value) {
        onModeChange(value as HeatmapViewMode);
      }
    }}
    testId="heatmap-mode-switcher"
  >
    {MODE_OPTIONS.map((option) => (
      <ToggleButton
        key={option.value}
        value={option.value}
        text={option.label}
        testId={`heatmap-mode-${option.value}`}
      />
    ))}
  </ToggleButtonGroup>
);
